import { render, staticRenderFns } from "./add-bank-card.vue?vue&type=template&id=1a291a34&scoped=true&"
import script from "./add-bank-card.vue?vue&type=script&lang=js&"
export * from "./add-bank-card.vue?vue&type=script&lang=js&"
import style0 from "./add-bank-card.vue?vue&type=style&index=0&id=1a291a34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a291a34",
  null
  
)

export default component.exports